import React, {memo} from "react";
import dayjs from 'dayjs';
import TransactionLink from "../../../../TransactionLink";
import {t} from "@lingui/macro";

function Date(props) {
    const { record } = props;

    if (record.rowType === 'total')
        return t`TOTAL`;
    if (record.rowType === 'spacer')
        return null;

    const label = dayjs(record.date).format('DD/MM/YYYY');

    return (
        <span className="BaseTable__row-cell-text date">
            <TransactionLink transaction={record} label={label} />
        </span>
    );
}
export default memo(Date);
